import withSupportAreaContext from '~/withSupportAreaContext';
import { default as MyTripsLoginValueProposition } from '~/components/ValueProposition';

export default withSupportAreaContext(MyTripsLoginValueProposition);
